module.exports = __webpack_public_path__ + "static/media/program_full_fr.3e859841.svg";